import { useEffect, useState } from "react";

export const useStandardsModalActiveTab = (tabsClass: string) => {
  const [activeTab, setActiveTab] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let observer: MutationObserver | null = null;
    let intervalId: NodeJS.Timeout | null = null;

    const setupObserver = (tabsContainerElement: Element) => {
      if (!tabsContainerElement) return;

      observer = new MutationObserver(() => {
        const activeTabElement = Array.from(tabsContainerElement.children).find(
          (tab) =>
            tab instanceof HTMLElement && tab.dataset["selected"] === "true",
        ) as HTMLElement | undefined;

        setActiveTab(activeTabElement || null);
      });

      observer.observe(tabsContainerElement, {
        attributes: true,
        subtree: true,
        childList: true,
      });

      const initialActiveTab = Array.from(tabsContainerElement.children).find(
        (tab) =>
          tab instanceof HTMLElement && tab.dataset["selected"] === "true",
      ) as HTMLElement | undefined;

      setActiveTab(initialActiveTab || null);
    };

    const checkAndSetupObserver = () => {
      const tabsContainerElement =
        document.getElementsByClassName(tabsClass)[0];
      if (tabsContainerElement) {
        setupObserver(tabsContainerElement);
        if (intervalId) clearInterval(intervalId);
      }
    };

    intervalId = setInterval(checkAndSetupObserver, 100);

    return () => {
      if (observer) observer.disconnect();
      if (intervalId) clearInterval(intervalId);
    };
  }, [tabsClass]);

  return activeTab;
};
